// extracted by mini-css-extract-plugin
module.exports = {"tileWrapper":"Tile_tileWrapper__zG3_c","position":"Tile_position__cYwCw"};